<template lang="pug">

  //- COMPONENT TEMPLATE
  ul.hotsite-lista.lista(v-if="itens.length")
    li.item(v-for="item of itens", :key="item.id", :class="icone")
      router-link(v-if="rota", :to="{ name: rota, params: { id: item.slug } }", v-html="item.titulo")
      a(v-else-if="item.url", :href="item.url", v-html="item.titulo")

  //- LOADING TEMPLATE
  .loading-container.lista-loading(v-else)
    span.sr-only Carregando...
    each val in [1, 2, 3]
      .item
        .slot: .icone.animated
        .slot: .texto.animated

</template>

<script>
  export default {
    name: 'hotsite-lista',

    props: {
      itens: { type: Array, required: true },
      rota: { type: String, required: false },
      icone: { type: String, required: false }
    }

  }
</script>



// WEBPACK FOOTER //
// HotsiteLista.vue?e531f726